import { actionCreatorFactory } from 'typescript-fsa'

const actionCreator = actionCreatorFactory()

export const ClearErrorMessage = actionCreator('ClearErrorMessage')
